import Vue from 'vue';

import CustomizationSection from './CustomizationSection.vue';

function getSectionPayload() {
  if ('__customizationSectionSettings' in window && window.__customizationSectionSettings != null) {
    return window.__customizationSectionSettings;
  }
  const root = document.querySelector('[data-vue="customization-section"]');
  const raw = root && root.getAttribute('data-section');
  if (!raw) {
    return {};
  }
  try {
    return JSON.parse(raw);
  } catch (e) {
    console.error('Customization section: invalid data-section JSON', e);
    return {};
  }
}

new Vue({
  render(h) {
    return h(CustomizationSection, {
      props: {
        section: getSectionPayload(),
      },
    });
  },
}).$mount('[data-vue="customization-section"]');
